import React from "react";

export default function ProgressLoader({
  loaded,
  total,
  getProgressPercentage,
}) {
  if (total <= 0 || loaded >= total) return null;

  return (
    <div className="w-100 mb-2 mt-4">
      <div className="progress" style={{ height: "10px" }}>
        <div
          className="progress-bar progress-bar-striped progress-bar-animated bg-success"
          role="progressbar"
          style={{ width: `${getProgressPercentage()}%` }}
          aria-valuenow={getProgressPercentage()}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      <small className="text-muted">
        Loading data... {loaded} of {total}
      </small>
    </div>
  );
}
